"use client";

import { sendGTMEvent } from "@next/third-parties/google";
import Link from "next/link";
import type { CollectionNavItem } from "@/types/segments";
import { collectionNavigationLabels } from "@/components/collections/collectionLabels";

/** Only enabled collections supplied by the server appear in this navigation. */
export default function QuickFilters({ className = "", collections = [] }: { className?: string; collections?: CollectionNavItem[] }) {
    if (!collections.length) return null;
    return <nav aria-label="Quick collection links" className={`t-flex t-gap-2 ${className}`}>
        {collections.map(collection => <Link key={collection.id} href={`/cars/collections/${collection.slug}`}
            aria-label={collectionNavigationLabels(collection).full}
            onClick={() => sendGTMEvent({ event: "search", search_type: "quick_filter", filter_type: "collection", filter_value: collection.slug })}
            className="t-inline-flex t-min-h-11 t-flex-shrink-0 t-items-center t-rounded-lg t-border t-border-slate-300 t-bg-white t-px-3.5 t-py-2 t-text-sm t-font-medium t-text-automotive-dark t-no-underline t-transition-colors hover:t-border-automotive-primary hover:t-text-automotive-primary focus-visible:t-outline-none focus-visible:t-ring-2 focus-visible:t-ring-automotive-primary focus-visible:t-ring-offset-2">
            {collectionNavigationLabels(collection).short}
        </Link>)}
    </nav>;
}
